import BaseStore from "@/stateManagement/BaseStore";
import { StoreConfig } from "@datorama/akita";
import { singleton } from "tsyringe";

import type { RewardsReferralProgramEntity } from "../models/RewardsReferralProgramEntities";

export interface RewardsReferralProgramState {
    referralProgram: RewardsReferralProgramEntity | null;
}

const createInitialState = (): RewardsReferralProgramState => ({
    referralProgram: null,
});

@singleton()
@StoreConfig({ name: "RewardsReferralProgramStore" })
class RewardsReferralProgramStore extends BaseStore<RewardsReferralProgramState> {
    constructor() {
        super(createInitialState());
    }
}

export default RewardsReferralProgramStore;
